export enum ApiRoutesAiReview {
  Root = "admin/ai-review"
}

export enum AiReviewSubRoute {
  Count = "count"
}

export const AI_REVIEW_QUERY_KEY = "ai-review";
